import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppMode } from '../models/app-mode.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root',
})
export class AppModeService {
  constructor(private authService: AuthService) {}

  getAppMode(): AppMode {
    return this.authService.getAppMode();
  }

  getAppModeChanges(): Observable<AppMode> {
    return this.authService.getAppModeChanges();
  }

  isEmergencyMode(mode: AppMode = this.getAppMode()): boolean {
    return mode === 'emergency';
  }

  isHospitalityMode(mode: AppMode = this.getAppMode()): boolean {
    return mode === 'hospitality';
  }
}
